import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AlertMessageModel } from '../../models/alert-message.model';
import { AlertMessageStore } from '../../stores/alert-message.store';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AlertContextEnum } from '../../enums/alert-context.enum';

@Component({
  selector: 'app-alert-messages',
  templateUrl: './alert-messages.component.html',
  styleUrls: ['./alert-messages.component.scss'],
  standalone: false,
})
export class AlertMessagesComponent implements OnInit, OnDestroy {
  @Input()
  maximumNumberOfMessages = 3;
  @Input()
  contexts: AlertContextEnum[] = [];

  public readonly alertMessages: AlertMessageModel[] = [];

  private subscriptions: Subscription[] = [];

  constructor(private readonly alertMessageStore: AlertMessageStore) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.alertMessageStore.get(AlertContextEnum.Global).pipe(filter(alertMessage => alertMessage?.target === undefined))
      .subscribe(alertMessage => {
        this.createAlertMessage(alertMessage);
      }));
    this.contexts.forEach(context => {
      this.subscriptions.push(this.alertMessageStore.get(context).pipe(filter(alertMessage => alertMessage?.target === undefined))
        .subscribe(alertMessage => {
          this.createAlertMessage(alertMessage);
        }));
    });

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private createAlertMessage(alertMessage?: AlertMessageModel): void {
    if (alertMessage) {

      if (this.alertMessages.length >= this.maximumNumberOfMessages) {
        this.alertMessages.splice(0, this.alertMessages.length - this.maximumNumberOfMessages + 1);
      }

      this.alertMessages.push(alertMessage);
      this.alertMessageStore.setConsumed(alertMessage.context);
    }
  }


}
